<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<div [formGroup]="formContacto" fxLayout="row" fxFlex="100">
    <div formArrayName="contactos" fxFlex="100">
      <div fxLayout="row wrap">
        <ng-container *ngFor="let contacto of contactos.controls; let i=index">
          <div [formGroupName]="i" class="{{contacto.get('tipoContacto').value === 'E-mail' ? 'pr-1' : ''}} mb-1" [fxFlex]="contacto.get('tipoContacto').value === 'E-mail' ? '50' : '50'"  [class.input-invalido]="contacto.value.invalido">
            <!--  Estes métodos devo pegar na nova implementação Fim  -->
            <ng-container *ngIf="contacto.get('tipoContacto').value === 'E-mail'">
              <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{ contacto.get('tipoContacto').value }} {{i + 1}} </mat-label>
                <input matInput type="email" name="tel-select-component-{{i}}"
                       autocomplete="false" (input)="aoEscrever(contacto, $event.target.name, i)"
                       [placeholder]="contacto.get('tipoContacto').value"
                       [readonly]="accao === actions.detalhes"
                       formControlName="contacto" maxlength="60"/>
              </mat-form-field>
            </ng-container>

            <ng-container  *ngIf="contacto.get('tipoContacto').value ==='ConfigPhone' || contacto.get('tipoContacto').value ==='Telemóvel' || contacto.get('tipoContacto').value ==='Fax'">
              <app-phone [id]="i" formControlName="contacto"
                         [label]="contacto.get('tipoContacto').value"
                         translateYValue="0" [accao]="accao"
                         (keydown)="onInput(i, contacto)" [paises]="paises">
              </app-phone>
            </ng-container>
          </div>
        </ng-container>
      </div>
